import React from 'react';

export const WarningIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="8" stroke="#F68C24" strokeWidth="1.5" />
        <path d="M9 5L9 10" stroke="#F68C24" strokeWidth="1.5" strokeLinecap="round" />
        <circle r="0.875" transform="matrix(-1 0 0 1 9.02539 12.875)" fill="#F68C24" />
    </svg>
);
